import React from 'react';
import { useTranslation } from 'react-i18next';
import backgroundImage from '../../assets/images/backgroundhome.jpg';
import BookButton from './BookButton';
import { HashLink as Link } from 'react-router-hash-link';

function LandingPage({ setFocus }) {
  const { t } = useTranslation();
  return (
    <div
      className="relative text-white bg-cover bg-center min-h-[90vh] lg:min-h-screen py-20 px-6 sm:px-12 lg:px-24 xl:px-48 flex items-center justify-start overflow-hidden"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {/* High-contrast gradient overlay to ensure text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/30 z-0"></div>

      <div className="relative text-left z-10 max-w-4xl">
        {/* Main Brand Title */}
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-wide mb-2">
          Nevski<span className="text-[#FFD82D]">Fit</span>
        </h1>

        {/* Catchphrase */}
        <h3 className="text-xl sm:text-3xl lg:text-4xl font-semibold leading-snug mb-8 sm:mb-10">
        {t('home.landing.tagline')}
        </h3>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-5">
          <Link
            to="/#inPersonCoachingInfo"
            onClick={() => setFocus('inPerson')}
            className="focus:outline-none"
          >
            <BookButton text={t('home.landing.homeCoaching')} />
          </Link>
          {/* <Link
            to="/#onlineCoachingInfo"
            onClick={() => setFocus('online')}
            className="focus:outline-none"
          >
            <BookButton text={t('home.landing.onlineCoaching')} />
          </Link> */}
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
